import { storeToRefs } from "pinia";
import { useTasksStore } from "@/stores/v2";
import { isChallenge } from "@/stores/v2/tasks/utils";
import { WeightRecord } from "@/types/v2";
import { useWeight } from "@/composables/tasks/challenge/useChallengeWeight";

export function useChallengeProgress() {
  // ===================================================================
  // Store
  // ===================================================================
  const { activeTask } = storeToRefs(useTasksStore());
  const { isIndividualWeightType } = useWeight();

  // ===================================================================
  // GETTERS
  // ===================================================================
  // Get Configuration Challenge Progress
  const getConfigurationChallengeProgress = (configKey: string): number => {
    if (!activeTask.value || !isChallenge(activeTask.value)) return 0;

    const configuration = activeTask.value.details.configurations.find(
      (config) => config.key === configKey
    );
    if (!configuration) return 0;

    return (
      configuration.progressData?.reduce(
        (sum: number, item: any) => sum + (item.challenged || 0),
        0
      ) || 0
    );
  };

  // Get Configuration Weight Progress
  const getConfigurationWeightProgress = (configurationKey: string): number => {
    if (!activeTask.value || !isChallenge(activeTask.value) || !isIndividualWeightType.value) return 0;

    if (!activeTask.value.details.weightConfiguration.progressData) {
      activeTask.value.details.weightConfiguration.progressData = [];
    }

    return activeTask.value.details.weightConfiguration.progressData
      .filter((record: WeightRecord) => record.configurationKey === configurationKey).length;
  };

  return {
    getConfigurationChallengeProgress,
    getConfigurationWeightProgress,
  };
}